import { routeGroup } from '#/routing/routes';

export const cmsRootRoute = routeGroup.rootRoute();

export const cmsSplatRoute = routeGroup.route('*');
